import { type MCPServerInfo } from '../../types';

const GongServer: MCPServerInfo = {
  serverId: 'GONG',
  name: 'Gong',
  slug: 'gong',
  description:
    'Official Gong remote MCP Server with OAuth. Access call recordings, transcripts, and conversation intelligence directly from your AI assistant.',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://api.gong.io/mcp'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default GongServer;
